import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { withRouter } from 'react-router';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(location => {
      if (this.state.hasError && this.state.pathname !== location.pathname) {
        this.setState({
          hasError: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidCatch(error, info) {
    const { captureException } = this.context;

    import(
      /* webpackChunkName: "sourcemapped-stacktrace" */ 'sourcemapped-stacktrace'
    )
      .then(({ mapStackTrace }) => {
        mapStackTrace(error.stack, mappedStack => {
          error.stack = mappedStack.join('\n'); // eslint-disable-line no-param-reassign
          captureException(error, { extra: info });
        });
      })
      .catch(() => captureException(error, { extra: info }));

    this.setState({
      error,
      hasError: true,
      pathname: this.props.location.pathname,
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.onError(this.state.error || {});
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  onError: PropTypes.func.isRequired,
  children: PropTypes.node,
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

ErrorBoundary.defaultProps = {
  children: undefined,
};

export default withRouter(ErrorBoundary);

ErrorBoundary.contextType = AppContext;
